// import { nanoid, customAlphabet } from "nanoid/non-secure";

//子应用与导航配置
const navAndSonAppConfigDatas = window.globalSonAppMainNavConfig || [];

const mapAppConfigDatas = new Map();
navAndSonAppConfigDatas.map((item) => {
  mapAppConfigDatas.set(item.id, item);
});

//导航菜单
const menuDatas = [...navAndSonAppConfigDatas].filter((item) => {
  return item.inMenuShow === true;
});

//子应用
const sonAppDatas = [...navAndSonAppConfigDatas].filter((item) => {
  return item.sonApp === true;
});

export { mapAppConfigDatas, menuDatas, sonAppDatas };
